import { useEffect, useState } from 'react'
import { useApi } from '../../lib/useApi'
import { useQueryClient } from '@tanstack/react-query'

function Backdrop({ onClose, children }) {
  return (
    <div className="fixed inset-0 z-40 grid place-items-center px-4" onClick={onClose}
         style={{ background: 'rgba(0,0,0,0.6)' }}>
      <div onClick={(e) => e.stopPropagation()}
           className="w-full max-w-md border border-white/10 rounded-lg p-5 animate-system-open"
           style={{ background: 'var(--bg)' }}>
        {children}
      </div>
    </div>
  )
}

function ModalForm({ title, fields, onSave, onClose }) {
  const [v, setV] = useState({})
  return (
    <Backdrop onClose={onClose}>
      <div className="section-h mb-3">{title}</div>
      <div className="space-y-3">
        {fields.map((f) => (
          <label key={f.key} className="flex flex-col gap-1">
            <span className="label-mini">{f.label}</span>
            <input type={f.type || 'text'} value={v[f.key] ?? ''}
                   onChange={(e) => setV({ ...v, [f.key]: f.type === 'number' ? Number(e.target.value) : e.target.value })}
                   className="bg-transparent border border-white/15 rounded-md px-3 py-2 text-sm focus:border-[var(--accent)] outline-none" />
          </label>
        ))}
      </div>
      <div className="mt-5 flex gap-2 justify-end">
        <button onClick={onClose} className="px-4 py-2 rounded border border-white/15 text-sm">Cancel</button>
        <button onClick={() => { onSave(v); onClose() }} className="px-4 py-2 rounded bg-[var(--accent)] text-black font-semibold text-sm">Save</button>
      </div>
    </Backdrop>
  )
}

function makeModal(title, fields) {
  return function Modal({ open, onClose }) {
    const api = useApi()
    const qc  = useQueryClient()
    if (!open) return null
    return <ModalForm title={title} fields={fields} onClose={onClose}
      onSave={(v) => api.put('/daily', { values: v }).then(() => qc.invalidateQueries({ queryKey: ['daily-today'] }))} />
  }
}

export const WakeModal       = makeModal('Wake',       [['wake', 'time', 'Wake'], ['energy', 'number', 'Energy 1-10']].map(([k,t,l]) => ({key:k, type:t, label:l})))
export const SmartphoneModal = makeModal('Phone',      [{key:'phone_first_use', type:'time', label:'First phone use'}])
export const EveningModal    = makeModal('Abend',      [{key:'fokus', type:'text', label:'Fokus heute'}, {key:'diary', type:'text', label:'Diary'}])
export const BedtimeModal    = makeModal('Bedtime',    [{key:'bed', type:'time', label:'Bed'}])
